import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Contact } from '../../../../sic-lib/types/Contact';
import { ListType } from '../../../../sic-lib/types/Lists';
import DialogAddGroupContacts from '../../DialogAddGroupContacts/DialogAddGroupContacts';
import DialogConfirmDeleteContact from '../../DialogConfirmDeleteContact/DialogConfirmDeleteContact';
import DialogModifyContactField from '../../DialogModifyContactField/DialogModifyContactField';
import DialogRemoveGroupContacts from '../DialogRemoveGroupContacts/DialogRemoveGroupContacts';
import MenuTableContactActionsRaw from './MenuTableContactActionsRaw/MenuTableContactActionsRaw';

const useStyles = makeStyles()((theme: Theme) => ({
    button: {
        padding: theme.spacing(1),
    },
}));

export enum MenuContactActionDialogs {
    none = -1,
    addGroup = 0,
    removeGroup,
    editContact,
    deleteContact,
}

interface Props {
    contact: Contact;
    appliedListId: number;
    appliedListType: ListType;
}

export default function MenuTableContactActions({
    contact,
    appliedListId,
    appliedListType,
}: Props) {
    const { classes } = useStyles();

    const [dialogOpen, setDialogOpen] = React.useState<MenuContactActionDialogs>(
        MenuContactActionDialogs.none,
    );

    const handleOpenDialog = (event: React.MouseEvent<HTMLElement>) => {
        const { dialogId } = event.currentTarget.dataset;

        if (dialogId) {
            setDialogOpen(+dialogId as MenuContactActionDialogs);
        }

        setAnchorEl(null);
    };

    const handleCloseDialog = () => {
        setDialogOpen(MenuContactActionDialogs.none);
    };

    const [menuId] = React.useState<string>(`menu_action_${contact.contactId}`);

    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

    const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            <IconButton
                onClick={handleOpenMenu}
                aria-haspopup="true"
                aria-controls={menuId}
                aria-expanded={Boolean(anchorEl)}
                className={classes.button}
                size="large"
            >
                <MoreVertIcon />
            </IconButton>
            <MenuTableContactActionsRaw
                listType={appliedListType}
                anchorEl={anchorEl}
                menuId={menuId}
                onOpenDialogHandler={handleOpenDialog}
                onCloseHandler={handleCloseMenu}
                listId={appliedListId}
            />
            {
                /*
                    TIP: dialogs do not unmount when closed(?) presevering state: force
                    an unmount with conditional rendering
                */
                dialogOpen === MenuContactActionDialogs.addGroup && (
                    <DialogAddGroupContacts
                        isOpen={dialogOpen === MenuContactActionDialogs.addGroup}
                        contactIds={[contact.contactId]}
                        onDoneHandler={handleCloseDialog}
                    />
                )
            }
            {dialogOpen === MenuContactActionDialogs.removeGroup && (
                <DialogRemoveGroupContacts
                    isOpen={dialogOpen === MenuContactActionDialogs.removeGroup}
                    listId={appliedListId}
                    contactIds={[contact.contactId]}
                    onCloseHandler={handleCloseDialog}
                />
            )}
            {dialogOpen === MenuContactActionDialogs.editContact && (
                <DialogModifyContactField
                    isOpen={dialogOpen === MenuContactActionDialogs.editContact}
                    contact={contact}
                    onDoneHandler={handleCloseDialog}
                />
            )}
            {dialogOpen === MenuContactActionDialogs.deleteContact && (
                <DialogConfirmDeleteContact
                    isOpen={dialogOpen === MenuContactActionDialogs.deleteContact}
                    contactId={contact.contactId}
                    onDoneHandler={handleCloseDialog}
                />
            )}
        </React.Fragment>
    );
}
